import { useEffect, useRef } from "react";

const useDidUpdateEffect = (fn, inputs) => {
  const isMountedRef = useRef(false);

  useEffect(() => {
    if (isMountedRef.current) {
      return fn();
    } else {
      isMountedRef.current = true;
    }
  }, inputs);
};

export default useDidUpdateEffect;